import { render, staticRenderFns } from "./SundryItemAdjustStockLogSummary.vue?vue&type=template&id=535a0e48&lang=true&"
import script from "./SundryItemAdjustStockLogSummary.vue?vue&type=script&lang=js&"
export * from "./SundryItemAdjustStockLogSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports